import { Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';

export type ArrowUpRightDirection = 'up-right' | 'down-right';

@Component({
  standalone: true,
  selector: 'app-arrow-up-right',
  imports: [NgStyle],
  templateUrl: './arrow-up-right.html',
  styleUrl: './arrow-up-right.scss',
})
export class ArrowUpRight {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
  direction = input<ArrowUpRightDirection>('up-right');

  rotation = computed(() => (this.direction() === 'down-right' ? 90 : 0));
}
